import React from 'react';
import {
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
} from 'reactstrap';
import classNames from 'classnames';

import ModalPetInfo from '../../Common/ModalPetInfo';
import { AttachmentsTab } from '../../../../shared/components/Modals/AttachmentsTab';
import { FooterButtons } from '../../../../shared/components/Modals/FooterButtons';

import { InquiryMainInfoTab } from './InquiryMainInfoTab';
import { InquiryInternalCommentsTab } from './InquiryInternalCommentsTab';
import { InquiryMessageModal } from '../../../modals/InquiryMessage';
import {
  tab,
  useInquiryModalContext,
} from '../utils/InquiryModalContext';

export function InquiryModal() {
  const {
    isInquiryModalOpen,
    inquiryData,
    closeInquiryModal,
    activeTab,
    setActiveTab,
  } = useInquiryModalContext();

  const isDataAvailable = !!Object.values(inquiryData)?.length;
  const { photos, documents } = inquiryData;

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const hasAttachments = ({ photos, documents }) => {
    return photos?.length > 0 || documents?.length > 0;
  };

  const shouldIncludeTab = (tabItem) => {
    if (tabItem === tab.ATTACHMENTS) {
      return hasAttachments({ photos, documents });
    }
    return true;
  };

  const filteredTabs = Object.values(tab).filter(shouldIncludeTab);

  const TabDataMap = {
    [tab.MAIN_INFO]: <InquiryMainInfoTab />,
    [tab.ATTACHMENTS]: (
      <AttachmentsTab photos={photos} documents={documents}>
        <FooterButtons
          onClose={closeInquiryModal}
          showSaveButton={false}
        />
      </AttachmentsTab>
    ),
    [tab.INTERNAL_COMMENTS]: <InquiryInternalCommentsTab />,
  };

  return (
    <>
    <Modal
  isOpen={isInquiryModalOpen}
  toggle={closeInquiryModal}
  size="xl"
  backdrop="static"
  className="model-form inquiry-details-modal"
>
      <ModalHeader className="pet-summary-wrapper">
        {inquiryData?.petSummary && (
          <ModalPetInfo
            petSummary={inquiryData.petSummary}
            avatar={inquiryData.petSummary.avatar}
            title={`Inquiry\nDetails`}
          />
        )}
      </ModalHeader>
      <ModalBody>
        <Nav tabs>
          {filteredTabs.map((tab) => (
            <NavItem key={tab}>
              <NavLink
                className={classNames({ active: activeTab === tab })}
                onClick={() => toggleTab(tab)}
              >
                {tab}
              </NavLink>
            </NavItem>
          ))}
        </Nav>

        {isDataAvailable && (
          <TabContent activeTab={activeTab}>{TabDataMap[activeTab]}</TabContent>
        )}
      </ModalBody>
    </Modal>
    <InquiryMessageModal />
    </>
  );
}
